import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { EmojiIcon } from '../EmojiIcon';
import styles from './QuestionScaleSlideV2.css';

const cx = classnames.bind(styles);
const DELAY = 600;

function QuestionScaleSlideV2({ statement, question, answers, submitAnswer, userResponse = {}, submitTemporaryAnswer, id, delay = DELAY, spriteVersion }) {
    const [isPending, setIsPending] = useState(false);

    useEffect(() => {
        if (id) {
            setIsPending(false);
        }
    }, [id]);

    useEffect(() => {
        if (userResponse.id && userResponse.isPending) {
            setIsPending(true);

            const { isPending: isTemporaryPending, ...answerData } = userResponse; /* eslint-disable-line */

            const timeoutId = setTimeout(() => {
                submitAnswer(answerData)();
            }, delay);

            return () => clearTimeout(timeoutId);
        }
    }, [userResponse.id, userResponse.isPending]);

    const handleChange = answer => () => {
        if (isPending) return;

        submitTemporaryAnswer({ ...answer, questionId: id, question, isPending: true });
    };

    return (
        <div className={styles.form} key={id}>
            <div className={styles.textGroup}>
                <p className={styles.statement}>{statement}</p>
                <p className={styles.question}>{question}</p>
            </div>
            <div className={styles.scaleWrapper}>
                <ul className={styles.scale}>
                    {answers.map(answer => {
                        const isChecked = userResponse?.id === answer.id;

                        return (
                            <li key={answer.id} className={cx('answer', { checked: isChecked })}>
                                <button
                                    type='button'
                                    onClick={handleChange(answer)}
                                    className={styles.answerButton}
                                    aria-label={answer.text}
                                    aria-pressed={isChecked}
                                >
                                    <EmojiIcon name={answer.icon} version={spriteVersion} />
                                </button>
                            </li>
                        );
                    })}
                </ul>
                <div className={styles.labels}>
                    <span>{answers[0]?.text}</span>
                    <span>{answers[answers.length - 1]?.text}</span>
                </div>
            </div>
        </div>
    );
}

QuestionScaleSlideV2.propTypes = {
    statement: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    answers: PropTypes.array.isRequired,
    submitAnswer: PropTypes.func.isRequired,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object,
    id: PropTypes.number.isRequired,
    delay: PropTypes.number,
    spriteVersion: PropTypes.string.isRequired
};

export {
    QuestionScaleSlideV2
};
